import React, { useState } from "react";
import { Consent5000Dialog } from "../../dialogs/Consent5000Dialog";
import { DeleteMeDialog } from "../../dialogs/DeleteMeDialog";
import { useConsentsForCandidate } from "../../../user/useConsentsForCandidate";
import { withWSErrorContainer } from "../../../error/withWSErrorContainer";

interface ConsentDeleteDialogsProps {}

export const ConsentDeleteDialogs = withWSErrorContainer(
  (props: ConsentDeleteDialogsProps) => {
    const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);

    const { hasMissing5000Consent, isConsentFetched } =
      useConsentsForCandidate();

    if (!isConsentFetched) {
      return null;
    }

    return (
      <>
        {!!hasMissing5000Consent && (
          <Consent5000Dialog setOpenDeleteDialog={setShowDeleteDialog} />
        )}

        {!!showDeleteDialog && (
          <DeleteMeDialog
            onDismiss={() => {
              setShowDeleteDialog(false);
            }}
          />
        )}
      </>
    );
  }
);
